import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const SubscriptionRewardsPattern: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/subscription-rewards-pattern.excalidraw"
    title="Selling Software via Subscriptions + LM + Rewards"
    subtitle="The generic Business Builder pattern for automated onboarding, module access, and token-based retention"
  />
);

export default SubscriptionRewardsPattern;
